import { render, staticRenderFns } from "./BookingPolicyCard.vue?vue&type=template&id=b1181802&"
import script from "./BookingPolicyCard.vue?vue&type=script&lang=js&"
export * from "./BookingPolicyCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingPolicyCard.vue?vue&type=style&index=0&id=b1181802&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports